import {gql} from '@apollo/client';
import {PopReviewAction, PopReviewActionResult} from '../types/PopReviewType';
import {PopReviewFiltersTypeInput} from '../queries/getPopReviewPageList';

/**
 * 提交 POP 审核（一次一单，批量由前端逐条调用）
 * 审核员由后端取当前登录账号，前端不传 —— 防止伪造审核人。
 */
export const SUBMIT_POP_REVIEW_ACTION = gql`
    mutation SubmitPopReviewAction(
        $reviewTaskId: String!
        $action: PopReviewActionType!
        $disqualifyReasonCodes: [String!]
        $reviewRemark: String
        $reviewRemarkLang: String
    ) {
        submitPopReviewAction(
            reviewTaskId: $reviewTaskId
            action: $action
            disqualifyReasonCodes: $disqualifyReasonCodes
            reviewRemark: $reviewRemark
            reviewRemarkLang: $reviewRemarkLang
        ) {
            reviewTaskId
            appointmentId
            appointmentNumber
            status
            reviewerId
            reviewedAt
        }
    }
`;

export interface SubmitPopReviewActionResponse {
    submitPopReviewAction: PopReviewActionResult;
}

/**
 * 改判 POP 审核：对已审核的单重新提交结论（次数不限，覆盖当前结论并留痕）。
 * 入参与提交审核一致，仅后端走改判状态校验（待审单不可改判）。
 */
export const REVISE_POP_REVIEW_ACTION = gql`
    mutation RevisePopReviewAction(
        $reviewTaskId: String!
        $action: PopReviewActionType!
        $disqualifyReasonCodes: [String!]
        $reviewRemark: String
        $reviewRemarkLang: String
    ) {
        revisePopReviewAction(
            reviewTaskId: $reviewTaskId
            action: $action
            disqualifyReasonCodes: $disqualifyReasonCodes
            reviewRemark: $reviewRemark
            reviewRemarkLang: $reviewRemarkLang
        ) {
            reviewTaskId
            appointmentId
            appointmentNumber
            status
            reviewerId
            reviewedAt
        }
    }
`;

export interface RevisePopReviewActionResponse {
    revisePopReviewAction: PopReviewActionResult;
}

export interface SubmitPopReviewActionInput {
    reviewTaskId: string;
    action: PopReviewAction;
    /** 判定「不合格」时必填 */
    disqualifyReasonCodes?: string[];
    reviewRemark?: string;
    /** 备注原文语种（前端当前 locale）；后端据此填充富化 JSON 的 lang */
    reviewRemarkLang?: string;
}

/** 导出已审核记录（CSV，异步生成，去下载中心领取）；后端固定只导已审 */
export const GENERATE_POP_REVIEW_DOWNLOAD_REPORT = gql`
    mutation GeneratePopReviewDownloadReport(
        $filters: PopReviewFiltersTypeInput!
        $language: String
        $timezone: String
    ) {
        generatePopReviewDownloadReport(filters: $filters, language: $language, timezone: $timezone) {
            success
            errorCode
            fileName
        }
    }
`;

export interface GeneratePopReviewDownloadReportResponse {
    generatePopReviewDownloadReport: {
        success: boolean;
        /** NO_DATA / EXCEED_MAX_LIMIT:{上限} */
        errorCode?: string | null;
        fileName?: string | null;
    };
}

export interface GeneratePopReviewDownloadReportVariables {
    filters: PopReviewFiltersTypeInput;
    language?: string;
    timezone?: string;
}
